import { render } from "./BooksResultTable.vue?vue&type=template&id=16eb95c9&scoped=true"
import script from "./BooksResultTable.vue?vue&type=script&lang=js"
export * from "./BooksResultTable.vue?vue&type=script&lang=js"

import "./BooksResultTable.vue?vue&type=style&index=0&id=16eb95c9&lang=scss&scoped=true"

import exportComponent from "/opt/approot/build.20241112-151327-1a92bd59/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16eb95c9"]])

export default __exports__